export class Ticket {
  id: string;
  number: string;
  title: string;
  state: string;
  queue: string;
  service: string;
  sla: string;
  created: string;
  changed: string;
  product: string;
  version: string;
  versionIntegration: string;
  responsible: string;
  owner: string;
  articles: TicketArticle[];

  static sortByActionClient(a: Ticket, b: Ticket): number {
    const as = a.state.indexOf('action client');
    const bs = b.state.indexOf('action client');
    if (as > bs) {
      return as < bs ? 1 : -1;
    } else {
      return as < bs ? 1 : 0;
    }
  }
}

export class TicketArticle {
  fromCustomer: boolean;
  from: string;
  cc: string[];
  base64body: string;
  attachments: TicketAttachment[];
  time: number;
}

export class TicketAttachment {
  id: string;
  content: string;
  contentType: string;
  filename: string;
  link: string;
}

export class TicketSearchParams {
  page = 1;
  pagesize = 10;
  asc = false;
  sort = 'created';
  state = 'open';
  search = '';

  toParam(): {} {
    return {
      page: '' + this.page,
      pagesize: '' + this.pagesize,
      asc: '' + this.asc,
      sort: this.sort,
      state: this.state.trim(),
      search: this.search
    };
  }
}
